import React from 'react';
import { Helmet } from 'react-helmet';

function Onboarding_FAQ_Seo() {
    return (
        <div>
            <Helmet>
                <title>Ifepay on the App Store | Ifepay on the Play Store | Ifepay</title>
                <meta name="description" content="Ifepay: Download the Ifepay app from the App Store and Play Store. Seamlessly send money with ease and convenience. Enjoy secure and reliable money transfer services at your fingertips." />
                <meta property="og:title" content="Ifepay on the App Store | Ifepay on the Play Store | Ifepay" />
                <meta property="og:description" content="Ifepay: Download the Ifepay app from the App Store and Play Store. Seamlessly send money with ease and convenience. Enjoy secure and reliable money transfer services at your fingertips." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/onboarding-faq"/>
            </Helmet>
        </div>
    )
}

export default Onboarding_FAQ_Seo
